export default {
  path: '/lvy-vip-agreement',
  component: () => import('./VipAgreement'),
  meta: {
    title: '青藤之恋会员协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}